import * as THREE from 'three'
import glyphs from '../../content/glyphs.js'

/**
 * Metni harf setinden (tools/blender/glyphs.py) devrilebilen 3D harflerle yazar.
 * Harfler bbox genişliği + sabit boşlukla dizilir: font kerning'i çarpışma kutularını iç içe sokardı.
 */
export default class BlockText
{
    constructor(_options)
    {
        this.resources = _options.resources
        this.objects = _options.objects
    }

    static measure(_text)
    {
        let width = 0
        let previousWasGlyph = false

        for(const _char of _text)
        {
            const glyph = glyphs.chars[_char]

            if(!glyph)
            {
                width += glyphs.space
                previousWasGlyph = false
                continue
            }

            width += (previousWasGlyph ? glyphs.gap : 0) + glyph.width
            previousWasGlyph = true
        }

        return width
    }

    add(_text, _options)
    {
        const align = _options.align || 'left'
        const width = BlockText.measure(_text)
        const items = []

        let cursor = align === 'center' ? _options.x - width * 0.5 : _options.x
        let previousWasGlyph = false

        for(const _char of _text)
        {
            const glyph = glyphs.chars[_char]

            if(!glyph)
            {
                if(_char !== ' ')
                {
                    console.warn(`BlockText: "${_char}" harf setinde yok`)
                }
                cursor += glyphs.space
                previousWasGlyph = false
                continue
            }

            cursor += previousWasGlyph ? glyphs.gap : 0

            items.push(this.objects.add({
                base: this.resources.items[`glyph${glyph.code}Base`].scene,
                collision: this.resources.items[`glyph${glyph.code}Collision`].scene,
                offset: new THREE.Vector3(cursor, _options.y, 0),
                rotation: new THREE.Euler(0, 0, 0),
                duplicated: true,
                material: _options.material,
                shadow: { sizeX: glyph.width + 0.3, sizeY: glyphs.depth + 0.5, offsetZ: - 0.3, alpha: 0.35 },
                mass: _options.mass || 0.6,
                soundName: 'block'
            }))

            cursor += glyph.width
            previousWasGlyph = true
        }

        return { width, items }
    }
}
